<template>
<div class="home">

  <section class="hero is-fullheight">
    <div class="scene">
      <img src="@/assets/star.png" class="scene-item star star1" alt="">
      <img src="@/assets/star.png" class="scene-item star star2" alt="">
      <img src="@/assets/star.png" class="scene-item star star3" alt="">
      <img src="@/assets/star.png" class="scene-item star star4" alt="">
      <img src="@/assets/star.png" class="scene-item star star5" alt="">
      <img src="@/assets/star.png" class="scene-item star star6" alt="">
      <img src="@/assets/star.png" class="scene-item star star7" alt="">
      <img src="@/assets/star.png" class="scene-item star star8" alt="">
      <img src="@/assets/star.png" class="scene-item star star9" alt="">
      <img src="@/assets/star.png" class="scene-item star star10" alt="">
      <img src="@/assets/star.png" class="scene-item star star11" alt="">
      <img src="@/assets/star.png" class="scene-item star star12" alt="">
      <img src="@/assets/star.png" class="scene-item star star13" alt="">
      <img src="@/assets/star.png" class="scene-item star star14" alt="">
      <img src="@/assets/star.png" class="scene-item star star15" alt="">
      <img src="@/assets/star.png" class="scene-item star star16" alt="">
      <img src="@/assets/green3_sl.svg" class="scene-item green green3" alt="">
      <img src="@/assets/green2_sl.svg" class="scene-item green green2" alt="">
      <img src="@/assets/green1_sl.svg" class="scene-item green green1" alt="">
      <img src="@/assets/green-rocket_sl.svg" class="scene-item green green-rocket" alt="">

    </div>
    <div class="hero-body">
      <div class="container">
        <h1 class="title" v-html="pageContent['Hero Title']"></h1>
        <div v-if="false" class="trustpilot-c">
          <img src="@/assets/trustpilot.png" alt="" class="trustpilot-img">
        </div>
      </div>
    </div>
    <div class="hero-foot">
      <div class="container">
        <div class="hero-foot-padding">
          <router-link :to="{ name: 'form1', params: {} }" v-html="pageContent['Hero Button Text']" class="button is-primary is-large is-rounded is-fullwidth"></router-link>
        </div>
      </div>
    </div>
  </section>

  <section class="section section--features">
    <div class="container">
      <div class="content main-offer-terms-div">
        <p><strong>Please note</strong> - SpeedyLoans is not a direct lender, we are a broker and offer a loan matching service.</p>
        <p class="main-offer-terms" v-html="pageContent['Hero Button Description']"></p>
      </div>
      <div class="features">
        <div class="features-item features-item--quote">
          <div class="features-img-c">
            <img src="@/assets/quote.svg" class="features-img" alt="">
          </div>
          <p v-html="pageContent['Features Section -- 1 Item -- Text']"></p>
        </div>
        <div class="features-item features-item--quote">
          <div class="features-img-c">
            <img src="@/assets/rocket-small.svg" class="features-img" alt="">
          </div>
          <p v-html="pageContent['Features Section -- 2 Item -- Text']"></p>
        </div>
        <div class="features-item features-item--quote">
          <div class="features-img-c">
            <img src="@/assets/bad-credit.svg" class="features-img" alt="">
          </div>
          <p v-html="pageContent['Features Section -- 3 Item -- Text']"></p>
        </div>
      </div>
    </div>
  </section>

  <img src="@/assets/123-before.png" class="b123-before">

  <section class="section section--123">
    <div class="container">
      <div class="content">
        <h2 class="title" v-html="pageContent['Section1 - Title']"></h2>
        <vue-markdown class="content-inner" :source="pageContent['Section1 - Content']"></vue-markdown>
        <!-- <button class="button is-primary is-large is-rounded is-fullwidth" @click="isCardModalActive = true">
          Apply Now
        </button> -->
        <router-link :to="{ name: 'form1', params: {} }" class="button is-primary is-large is-rounded is-fullwidth">Apply Now</router-link>
      </div>
    </div>
  </section>

  <img src="@/assets/grey-before.png" class="footer-before">

  <section class="section section--why">
    <div class="container">
      <div class="content">
        <h2 class="title" v-html="pageContent['Section2 - Title']"></h2>
        <vue-markdown class="content-inner" :source="pageContent['Section2 - Content']"></vue-markdown>
      </div>
    </div>
    <img src="@/assets/green-before-clouds.png" class="footer-before">
  </section>

  <section class="section section--about">
    <div class="container">
      <div class="content">
        <h2 class="title" v-html="pageContent['Section3 - Title']"></h2>
        <vue-markdown class="content-inner" :source="pageContent['Section3 - Content']"></vue-markdown>
        <p>
          <router-link :to="{ name: 'form1', params: {} }" class="button is-primary is-large is-rounded is-fullwidth">Apply Now</router-link>
        </p>
        <p class="is-white has-text-centered">NEED HELP <router-link to="/contact" class="inherit-color">Contact us</router-link></p>
      </div>
    </div>
  </section>
  <svg width="500" height="80" viewBox="0 0 500 80" preserveAspectRatio="none" class="before-a before-a--creditcheck">
    <path d="M0,0 L0,40 Q250,80 500,40 L500,0 Z" fill="black" />
  </svg>

  <section v-if="false" class="section section--creditcheck">
    <div class="container">
      <div class="content">
        <h2 class="title" v-html="pageContent['Section4 - Title']"></h2>
        <vue-markdown class="content-inner" :source="pageContent['Section4 - Content']"></vue-markdown>
        <button class="button is-primary is-large is-rounded is-fullwidth" @click="isCardModalActive = true">
          Check My Eligibility
        </button>
        <div class="checks">
          <div class="check">
            <b-icon
              pack="fas"
              icon="check"
              size="is-large">
            </b-icon>
            <p>No credit <br>footprint</p>
          </div>
          <div class="check">
            <b-icon
              pack="fas"
              icon="check"
              size="is-large">
            </b-icon>
            <p>No<br> paperwork</p>
          </div>
          <div class="check">
            <b-icon
              pack="fas"
              icon="check"
              size="is-large">
            </b-icon>
            <p>100% <br>Secure</p>
          </div>
          <div class="check">
            <b-icon
              pack="fas"
              icon="check"
              size="is-large">
            </b-icon>
            <p>Loan confidence rating in under 60 seconds</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <svg width="500" height="80" viewBox="0 0 500 80" preserveAspectRatio="none" class="before-a before-a--getdecision">
    <path d="M0,0 L0,40 Q250,80 500,40 L500,0 Z" fill="black" />
  </svg>

  <section class="section section--getdecision">
    <div class="container">
      <div class="content">
        <h2 class="title" v-html="pageContent['Section5 - Title']"></h2>
        <vue-markdown class="content-inner" :source="pageContent['Section5 - Content']"></vue-markdown>
      </div>
    </div>
  </section>

  <section class="section section--faq">
    <div class="container">
      <div class="content">
        <h2 class="title" v-html="pageContent['Section6 - Title']"></h2>
        <vue-markdown class="content-inner" :source="pageContent['Section6 - Content']"></vue-markdown>
      </div>
    </div>
  </section>

</div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';
// import vueSlider from 'vue-slider-component';
import VueMarkdown from 'vue-markdown';
import axios from 'axios';
import store from '../store';

export default {
  name: 'home',
  components: {
    // vueSlider,
    VueMarkdown,
  },
  data() {
    return {
      storeState: store.state,
      pageContent: {
        id: 1,
        Title: 'Homepage',
        Slug: '/',
        'Hero Title': 'Flexible loans at rocket speed from £100 - £3500',
        'Hero Button Text': 'Let\'s Get Started <small>Free No Obligation Quote</small>',
        'Hero Button Description': `Representative 97% APR (fixed)<br>
                                    Representative example: Borrow £1000 for 24 months. Annual interest rate 70% (fixed). 24 equal instalments of £77.48. Total amount to repay £1,859.52.
                                    Representative 97% APR. Rates from 45.3% APR to 1575% APR - we provide a no obligation quote, your APR will be based on your personal circumstances.
                                    `,
        'Features Section -- 1 Item -- Text': '100% Free<br>No Obligation Quote',
        'Features Section -- 2 Item -- Text': 'Cash in as<br>Quick as 15 mins',
        'Features Section -- 3 Item -- Text': 'Bad Credit<br>Considered',
        'Section1 - Title': 'SpeedyLoans is as easy as <span class="is-block is-green">1–2–3</span>', // eslint-disable-next-line
        'Section1 - Content': '<ol class="ol-inside"><li><span class="normal"><strong>Fill out our Online Application:</strong> Tell us how much **you want** to borrow and how long you’ll need to pay it back. We’ll need some information from you, such as contact details, income/expenses, and your bank account details.\n</span></li><li><span class="normal"><strong>Get an Instant Decision:</strong> Find out instantly if your loan application has been pre approved, or if we need to conduct further checks. If we can offer you a loan, we\'ll show you exactly what you have to pay back, and when.\n            </span></li><li><span class="normal"><strong>Cash paid in 5 minutes:</strong> Once you accept our loan offer, and we have made any final application checks, we will pay your loan straight away. No waiting around, no upfront fees - just cash in your bank within 5 minutes**.\n</span></li></ol>',
        created_at: '2019-02-28T14:53:34.279Z',
        updated_at: '2019-02-28T14:55:29.872Z',
      },
      isNextModalActive: false,
      isCardModalActive: false,
      result: false,
      sliders: {
        moneySlider: {
          value: 400,
          min: 100,
          max: 3500,
          interval: 50,
          tooltip: false,
          dotSize: 32,
          processStyle: {
            backgroundColor: '#99d55a',
          },
          bgStyle: {
            backgroundColor: '#eeeeee',
          },
        },
        monthsSlider: {
          value: 4,
          plural: true,
          min: 1,
          max: 6,
          tooltip: false,
          dotSize: 32,
          processStyle: {
            backgroundColor: '#99d55a',
          },
          bgStyle: {
            backgroundColor: '#eeeeee',
          },
        },
      },
      RequestJSON: {
        Campaign: 'TEST',
        AffiliateId: 'RISE-UK1',
        // Timeout: 100,
        // SubAffiliate: null,
        TestOnly: true,
        SourceDetails: {
          Address: undefined,
          ClientUserAgent: navigator.userAgent,
          CreationUrl: 'http://speedyloans.co.uk',
          ReferringUrl: 'http://speedyloans.co.uk',
        },
      },
      Application: {
        AddressCity: '',
        AddressCounty: '',
        AddressMoveIn: '',
        AddressPostcode: '',
        AddressStreet1: '',
        BankAccountNumber: '',
        BankCardType: undefined,
        UsesOnlineBanking: false,
        BankRoutingNumber: '',
        ConsentToCreditSearch: true,
        ConsentToMarketingEmails: false,
        ConsentToMarketingSms: false,
        ConsentToMarketingPhone: false,
        DateOfBirth: '',
        IncomePaymentType: undefined,
        Email: '',
        EmployerIndustry: undefined,
        EmployerName: 'unemployed',
        EmploymentStarted: '',
        FirstName: '',
        HouseNumber: '',
        FollowingPayDate: '',
        HomePhoneNumber: '',
        HouseName: '',
        IncomeSource: undefined,
        JobTitle: '',
        LastName: '',
        LoanAmount: 400,
        MobilePhoneNumber: '',
        NextPayDate: '',
        PayAmount: undefined,
        PayFrequency: 0,
        ResidentialStatus: 0,
        Term: 3,
        Title: 0,
        WorkPhoneNumber: '',
        MonthlyMortgageRent: undefined,
        MonthlyCreditCommitments: undefined,
        OtherExpenses: undefined,
        Transport: undefined,
        Food: undefined,
        Utilities: undefined,
        ConfirmedByApplicant: true,
        MaritalStatus: 0,
        LoanProceedUse: 0,
        NumberOfDependents: 0,
        CombinedMonthlyHouseholdIncome: 0,
        ApplicationExtensions: [],
      },
      applicationFields: {
        Title: {
          1: 'Mr',
          2: 'Mrs',
          3: 'Ms',
          4: 'Miss',
        },
        MaritalStatus: {
          1: 'Single',
          2: 'Married',
          3: 'LivingTogether',
          4: 'Separated',
          5: 'Divorced',
          6: 'Widowed',
          7: 'Other',
        },
        NumberOfDependents: {
          0: 'None',
          1: 1,
          2: 2,
          3: 3,
          4: 4,
          5: '5+',
        },
        AddressesAvailable: [],
        ManualAddress: false,
        IncomeSource: {
          1: 'Self Employed',
          2: 'Employed Full Time',
          3: 'Employed Part Time',
          4: 'Employed Temporary',
          5: 'Pension',
          6: 'Disability Benefits',
          7: 'Benefits',
        },
        EmployerIndustry: {
          1: 'Construction\\Manufacturing',
          2: 'Military',
          3: 'Health',
          4: 'Banking\\Insurance',
          5: 'Education',
          6: 'Civil Service',
          7: 'Supermarket\\Retail',
          8: 'Utilities\\Telecom',
          9: 'Hotel, Restaurant and Leisure',
          10: 'Other, Office-based',
          11: 'Other, not Office-based',
          12: 'None',
          13: 'Driving\\Delivery',
          14: 'Administration\\Secretarial',
          15: 'Mid Level Management',
          16: 'Senior Level Management',
          17: 'Skilled Trade',
          18: 'Professional',
        },
        timeAtAddressYears: undefined,
        timeAtAddressMonths: undefined,
        timeEmployedYears: undefined,
        timeEmployedMonths: undefined,
        workNumber: undefined,
        homeNumber: undefined,
        mobNumber: undefined,
        NextPay: undefined,
        FollowingPay: undefined,
      },
      errors: {
        // messages: {
        //   phoneError: 'Must be valid Number',
        // },
      },
      badDates: {
        dates: [
          '2019-01-01',
          'April 19th, 2019',
          'April 22nd, 2019',
          'May 6th, 2019',
          'May 27th, 2019',
          'August 26th, 2019',
          'December 25th, 2019',
          'December 26th, 2019',
          'January 1st, 2020',
          'April 10th, 2020',
          // April 13th, 2020,
          // May 4th, 2020,
          // May 25th, 2020,
          // August 31st, 2020,
          // December 25th, 2020,
          // December 26th, 2020,
          // December 28th, 2020,
          // January 1st, 2019,
          // April 19th, 2019,
          // April 22nd, 2019,
          // May 6th, 2019,
          // May 27th, 2019,
          // August 26th, 2019,
          // December 25th, 2019,
          // December 26th, 2019,
          // January 1st, 2020,
          // April 10th, 2020,
          // April 13th, 2020,
          // May 4th, 2020,
          // May 25th, 2020,
          // August 31st, 2020,
          // December 25th, 2020,
          // December 26th, 2020,
          // December 28th, 2020
        ],
      },
      waiting: false,
      waitingText: '',
    };
  },
  mounted() {
    axios.get('https://cms.speedyloans.co.uk/lp1s/7')
      .then((response) => {
        // console.log(response);
        this.pageContent = response.data;
        if (response.data['Hero Button Description']) {
          this.pageContent['Hero Button Description'] += 'Rates from 45.3% APR to 1575% APR - we provide a no obligation quote, your APR will be based on your personal circumstances.';
        }
        document.title = response.data.Title;
      })
      .catch((error) => {
        console.log(error.response);
      });


    // Add ApplicationExtensions from query string
    if (this.$route.query.gclid) {
      this.Application.ApplicationExtensions.push({ gclid: this.$route.query.gclid });
      store.setGclid(this.$route.query.gclid);
    }
    if (this.$route.query.la) {
      store.setLa(this.$route.query.la);
    }
    if (this.$route.query.keyword) {
      store.setAwKeyword(this.$route.query.keyword);
    }
    if (this.$route.query.device) {
      store.setAwDevice(this.$route.query.device);
    }
    if (this.$route.query.matchtype) {
      store.setAwMatchtype(this.$route.query.matchtype);
    }
    if (this.$route.query.adpos) {
      store.setAwAdpos(this.$route.query.adpos);
    }
    if (this.$route.query.utm_source) {
      store.setUtmSource(this.$route.query.utm_source);
    }
    if (this.$route.query.utm_medium) {
      store.setUtmMedium(this.$route.query.utm_medium);
    }
    if (this.$route.query.utm_term) {
      store.setUtmTerm(this.$route.query.utm_term);
    }
    if (this.$route.query.utm_content) {
      store.setUtmContent(this.$route.query.utm_content);
    }
    if (this.$route.query.utm_campaign) {
      store.setUtmCampaign(this.$route.query.utm_campaign);
    }

    // Get user IP and store in SourceDetails
    axios.get('https://api.ipify.org')
      .then((response) => {
        console.log(response.data);
        this.RequestJSON.SourceDetails.Address = response.data;
      })
      .catch((error) => {
        console.log(error.response);
      });

    this.RequestJSON.Application = this.Application;
  },
  methods: {
    addressLookup(postcode, event) {
      if (event) event.preventDefault();
      axios.get(`https://api.getAddress.io/find/${postcode}?api-key=XFvWQjqVKEa_Rr-zbh4VGA17329&expand=true`)
        .then((response) => {
          this.applicationFields.AddressesAvailable = response.data.addresses;
          this.applicationFields.ManualAddress = true;
        })
        .catch((error) => {
          console.log(error.response);
          this.applicationFields.ManualAddress = 'error';
        });
    },
    chooseAddress(addressId) {
      // console.log(this.applicationFields.AddressesAvailable[addressId]);
      this.Application.HouseNumber = this.applicationFields.AddressesAvailable[addressId].building_number;
      this.Application.AddressStreet1 = this.applicationFields.AddressesAvailable[addressId].thoroughfare;
      this.Application.AddressCity = this.applicationFields.AddressesAvailable[addressId].town_or_city;
      this.Application.AddressCounty = this.applicationFields.AddressesAvailable[addressId].county;

      if (!this.Application.AddressCounty && this.Application.AddressCity === 'London') {
        this.Application.AddressCounty = 'Greater London';
      }
      // console.log(this.Application.HouseNumber);
    },
    timestampFromToday(years = 0, months = 0) {
      let timestamp = Math.round(new Date().getTime() / 1000); // getTimestamp of today in Milliseconds
      timestamp -= (years * 31536000) + (months * 2628003.6); // timestamp = years* how many hours in year + hours in month
      let newTime = new Date(timestamp * 1000); // convert back to timestamp
      newTime = (Date.parse(newTime) / 1000);
      return newTime * 1000;
    },
    employedTime(years = 0, months = 0) {
      // eslint-disable-next-line
      this.Application.EmploymentStarted = `\/Date(${this.timestampFromToday(years, months)})\/`;
    },
    addressTime(years = 0, months = 0) {
      // eslint-disable-next-line
      this.Application.AddressMoveIn = `\/Date(${this.timestampFromToday(years, months)})\/`;
    },
    dateOfBirtConvert(dateString) {
      let dateStamp = new Date(dateString).getTime() / 1000;
      dateStamp *= 1000;
      let eighteenYearsAgo = new Date();
      eighteenYearsAgo = eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
      console.log(`japa: ${eighteenYearsAgo}`);
      // day18YearsAgo.setMonth(day18YearsAgo.getMonth() – 12);
      // eighteenYearsAgo = eighteenYearsAgo.getTime() / 1000;
      console.log(dateStamp, eighteenYearsAgo);
      if (dateStamp < eighteenYearsAgo) { // check if age > 18
        // eslint-disable-next-line
        this.Application.DateOfBirth = `\/Date(${dateStamp})\/`;
      } else {
        console.log('Not old enough');
        // const dobError = "You must be at least 18+";
      }
    },
    // phoneConvert(num = 0, type) {
    //   if (num.length !== 10 && num.length !== 11) {
    //     // const numError = "<span> Number must be 10-11 Digits</span>";
    //     console.log('NumError', num.length);
    //     this.errors[`${type}Number`] = 'Must be valid Number';
    //   } else if (type) {
    //     this.errors[`${type}Number`] = '';
    //     const name = `${type}Number`;
    //     this.Application[name] = num;
    //     console.log(name, num.length);
    //   } else {
    //     this.Application.type = num;
    //   }
    // },
    nextPayDate(date, following = 0) {
      const todayDate = new Date().getTime() / 1000;
      let payDate = new Date(date).getTime() / 1000;
      if (payDate > todayDate) {
        this.errors.nextPayErr = '';
        // console.log('in Future', todayDate, payDate);
        let i;
        for (i = 0; i < this.badDates.dates.length; i += 1) {
          // console.log(this.badDates.dates[i], '<bad', date);
          if (date === this.badDates.dates[i]) {
            // console.log('badDate!');
            this.errors.nextPayErr = 'Pay Date must not be on a bank Holiday';
          }
        }
        if (payDate - 3888000 < todayDate) {
          this.errors.nextPayErr = '';
          // console.log('success');
          payDate *= 1000;
          if (following < 1) {
            // console.log('NextSuccess!');
            // eslint-disable-next-line
            this.Application.NextPayDate = `\/Date(${payDate})\/`;
          } else {
            // console.log('FollowSuccess!');
            // eslint-disable-next-line
            this.Application.FollowingPayDate = `\/Date(${payDate})\/`;
          }
        } else if (following < 1) {
          console.log(following);
          this.errors.followingPayErr = 'must be less than 45 days in the future';
        } else {
          this.errors.nextPayErr = 'must be less than 45 days in the future';
        }
      } else if (following < 1) {
        this.errors.followingPayErr = 'must be in the future';
      } else {
        this.errors.nextPayErr = 'must be in the future';
      }
    },
    applyForLoan() {
      // console.log(this.Application);
      this.result = this.Application;

      this.waiting = true;
      this.waitingText = 'Sending...';

      // send POST date
      const axiosConfig = {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          // 'App-Test-Response-Type': 'LenderMatchFound',
        },
      };

      axios.post('https://leads.pingyo.co.uk/application/submit', JSON.stringify(this.RequestJSON), axiosConfig)
        .then((response) => {
          // console.log(response);
          this.waitingText = 'Sent! Waiting for response...';
          if (response.status === 202) {
            setTimeout(() => {
              const correlationId = response.data.CorrelationId;
              axios.get(`https://leads.pingyo.co.uk/application/status/${correlationId}`)
                .then((secondResponse) => {
                  let progress = secondResponse.data.PercentageComplete;
                  if (progress !== 100) {
                    axios.get(`https://leads.pingyo.co.uk/application/status/${correlationId}`)
                      .then((thirdResponse) => {
                        progress = thirdResponse.data.PercentageComplete;
                        if (progress === 100) {
                          this.loanResult(thirdResponse);
                        } else {
                          this.loanResultFail();
                        }
                      })
                      .catch((thirdError) => {
                        console.log(thirdError.response);
                      });
                  } else if (progress === 100) {
                    this.loanResult(secondResponse);
                  }
                })
                .catch((secondError) => {
                  console.log(secondError.response);
                });
            }, 5000);
          }
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    loanResult(responseData) {
      const redirection = responseData.data.RedirectionUrl;
      if (!redirection) {
        this.loanResultFail();
      } else {
        this.loanResultSuccess(redirection);
      }
    },
    loanResultFail() {
      this.waiting = false;
      this.isCardModalActive = false;
      this.isNextModalActive = false;
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'No matching lenders found.',
      });
    },
    loanResultSuccess(redirectionUrl) {
      this.waiting = false;
      this.isCardModalActive = false;
      this.isNextModalActive = false;
      this.$swal({
        type: 'success',
        title: 'Success!',
        text: 'You will be redirected in 5 seconds. Press XXX if you don\'t want to wait',
        confirmButtonText: 'Go now!',
      }).then((result) => {
        if (result.value) {
          // redirect
          console.log(redirectionUrl);
        }
      });
      setTimeout(() => {
        // redirect after 5 sec
      }, 5000);
    },
    loadTestData() {
      this.RequestJSON.Application.AddressCity = 'London';
      this.RequestJSON.Application.AddressCounty = 'Greater London';
      // eslint-disable-next-line
      this.RequestJSON.Application.AddressMoveIn = '\/Date(1392204322000)\/';
      this.RequestJSON.Application.AddressPostcode = 'SE14 5AD';
      this.RequestJSON.Application.AddressStreet1 = 'New Cross Road';
      this.RequestJSON.Application.BankAccountNumber = '12312312';
      this.RequestJSON.Application.BankCardType = 4;
      this.RequestJSON.Application.UsesOnlineBanking = true;
      this.RequestJSON.Application.BankRoutingNumber = '121212';
      this.RequestJSON.Application.ConsentToCreditSearch = true;
      this.RequestJSON.Application.ConsentToMarketingEmails = true;
      this.RequestJSON.Application.ConsentToMarketingSms = true;
      this.RequestJSON.Application.ConsentToMarketingPhone = true;
      // eslint-disable-next-line
      this.RequestJSON.Application.DateOfBirth = '\/Date(662688000000)\/';
      this.RequestJSON.Application.IncomePaymentType = 4;
      this.RequestJSON.Application.Email = 'gdsaasd@dasdasd.com';
      this.RequestJSON.Application.EmployerIndustry = 2;
      this.RequestJSON.Application.EmployerName = 'Alphabet inc';
      // eslint-disable-next-line
      this.RequestJSON.Application.EmploymentStarted = '\/Date(1423740346000)\/';
      this.RequestJSON.Application.FirstName = 'Mariusz';
      this.RequestJSON.Application.HouseNumber = '192e';
      // eslint-disable-next-line
      this.RequestJSON.Application.FollowingPayDate = '\/Date(1550793600000)\/';
      this.RequestJSON.Application.HomePhoneNumber = '01123456789';
      this.RequestJSON.Application.HouseName = 'Test';
      this.RequestJSON.Application.IncomeSource = 2;
      this.RequestJSON.Application.JobTitle = '';
      this.RequestJSON.Application.LastName = 'Test Last Name';
      this.RequestJSON.Application.LoanAmount = 400;
      this.RequestJSON.Application.MobilePhoneNumber = '07123456789';
      // eslint-disable-next-line
      this.RequestJSON.Application.NextPayDate = '\/Date(1550793600000)\/';
      this.RequestJSON.Application.PayAmount = 5000;
      this.RequestJSON.Application.PayFrequency = 9;
      this.RequestJSON.Application.ResidentialStatus = 1;
      this.RequestJSON.Application.Term = 3;
      this.RequestJSON.Application.Title = '1';
      this.RequestJSON.Application.WorkPhoneNumber = '02123456789';
      this.RequestJSON.Application.MonthlyMortgageRent = 750;
      this.RequestJSON.Application.MonthlyCreditCommitments = 0;
      this.RequestJSON.Application.OtherExpenses = 75;
      this.RequestJSON.Application.Transport = 125;
      this.RequestJSON.Application.Food = 225;
      this.RequestJSON.Application.Utilities = 75;
      this.RequestJSON.Application.ConfirmedByApplicant = true;
      this.RequestJSON.Application.MaritalStatus = 1;
      this.RequestJSON.Application.LoanProceedUse = 5;
      this.RequestJSON.Application.NumberOfDependents = 0;
    },
  },
};
// Function for converting Date to string const dateString = date.replace('-', '');
// const year = dateString.substring(0, 4);
// const month = dateString.substring(4, 6);
// const day = dateString.substring(6, 8);
// const newDate = new Date(year, month - 1, day);
</script>

<style lang="scss">
body {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.button.is-primary {
  font-weight: 800;
  background-color: #ae33b5;
}
.button.is-primary:hover {
  background-color: #8e2394;
}

.hero.is-fullheight {
  min-height: calc(86vh - 5.5rem);
  // min-height: calc(500px);
  background: #7176bc;
  background: -moz-linear-gradient(top, #7176bc 0%, #ffffff 100%);
  background: -webkit-linear-gradient(top, #7176bc 0%,#ffffff 100%);
  background: linear-gradient(to bottom, #7176bc 0%,#ffffff 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#7176bc', endColorstr='#ffffff',GradientType=0 );
  color: #fff;
  position: relative;
  overflow: hidden;

  .hero-body {
    align-items: flex-start;
    padding-top: 2rem;
  }
  .title {
    color: #fff;
    font-weight: 800;
    font-size: 2.2rem;
    margin-bottom: 1rem;
  }
  .trustpilot-img {
    width: 100px;
  }
  .hero-foot-padding {
    padding: 0 2rem;
  }

  .main-offer-terms {
    font-size: 0.9rem;
    margin: 0.4rem 0;
    color: #000;
  }

  .scene {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    .star {
      position: absolute;
      width: 18px;
    }
    .star1 {
      top: 15px;
      left: 15px;
    }
    .star2 {
      width: 10px;
      top: 80px;
      left: 40px;
    }
    .star3 {
      width: 6px;
      top: 35%;
      left: 5%;
    }
    .star4 {
      width: 10px;
      top: 38%;
      left: 8%;
    }
    .star5 {
      width: 16px;
      top: 4%;
      left: 55%;
    }
    .star6 {
      width: 10px;
      top: 3%;
      left: 75%;
    }
    .star7 {
      width: 6px;
      top: 2%;
      left: 85%;
    }
    .star8 {
      width: 12px;
      top: 12%;
      left: 95%;
    }
    .star9 {
      width: 5px;
      top: 20%;
      left: 94%;
    }
    .star10 {
      width: 9px;
      top: 30%;
      left: 94%;
    }
    .star11 {
      width: 4px;
      top: 35%;
      left: 86%;
    }
    .star12 {
      width: 10px;
      top: 45%;
      left: 86%;
    }
    .star13 {
      left: 35%;
      top: 20%;
    }
    .star14 {
      left: 25%;
      top: 40%;
    }
    .star15 {
      left: 75%;
      top: 30%;
    }
    .star16 {
      top: 45%;
      right: 39%;
    }
    .green {
      position: absolute;
      left: 0;
      bottom: -5%;
    }
    .rocket {
      position: absolute;
      left: 0;
      bottom: 0;
    }
    .green, .rocket {
      transform: scale(4.5);
      transform-origin: bottom;
    }

    img.scene-item.green.green-rocket {
      bottom: -10% !important;
      transform: scale(.5) !important;
    }
  }
}

.slider-section p {
  font-weight: 600;
  font-size: 1.05rem;
}
.amount-c {
  font-weight: 800;
  font-size: 1.6rem;
  background: #efefef;
  border: 2px solid #74ba6c;
  box-shadow: 0px 0px 20px rgba(116, 186, 108, 0.33);
  border-radius: 50px;
  display: inline-block;
  padding: 5px 10px 2px;
  line-height: 1.3;
  margin: 10px 0;
  width: 180px;
}

.loan-summary {
  display: flex;
  flex: 1 0 auto;
  border-top: 1px solid #eeeeee;
  padding: 18px 0 10px;
  font-size: 0.7rem;
  line-height: 1.2;
  justify-content: space-evenly;
}
.loan-summary strong {
  font-size: 1rem;
  line-height: 1.8;
}
.loan-summary-txt {
  font-size: 0.8rem;
  margin-bottom: 1rem;
}
.next-button-c {
  margin-bottom: 1rem;
}
.disclaimer {
  font-size: 0.7rem;
  text-align: left;
  background: #e1e1e1;
  margin-left: -1rem;
  margin-right: -1rem;
  padding: 0.6rem;
}

.vue-slider-component .vue-slider-dot .vue-slider-dot-handle {
  background-color: #74ba6c;
  box-shadow: none;
}
.vue-slider-component.vue-slider-horizontal:after,
.vue-slider-component.vue-slider-horizontal:before {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  width: 25px;
  height: 25px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 25px;
  font-weight: 800;
}
.vue-slider-component.vue-slider-horizontal:before {
  content: "-";
  left: 0;
  background-color: #99d55a;
  color: #fff;
}

.vue-slider-component.vue-slider-horizontal:after {
  content: "+";
  right: 0;
  background-color: #eeeeee;
  color: #74ba6c;
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  font-weight: 600;
  margin-left: -0.3rem;
  margin-right: -0.3rem;
}

.slider {
  padding: 0.6rem 0 1.2rem;
}

.form-header {
  margin: 1.5rem 0;
}

.form-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
}
.form-header .small {
  font-size: 0.85rem;
}
.form-header hr {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.form-terms {
  font-size: 0.85rem;
}
.label {
  text-align: left;
}
.field:not(:last-child) {
  margin-bottom: 0.85rem;
}

.section--features {
  background-color: #acddae;
  margin-top: -1px;
  position: relative;
}
.section--why {
  background-color: #f9f9f9;

  >.container {
    background-image: url("../assets/rocket-white.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
.section--about {
  background-color: #acddae;
}
.section--creditcheck {
  background-color: #f9f9f9;

  >.container {
    background-image: url("../assets/rocket-white.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
.section--faq {

  >.container {
    background-image: url("../assets/rocket-grey.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}

.content .title {
  color: #343434;
  font-weight: 800;
  font-size: 2.1rem;
  margin-bottom: 1rem;
}
.is-green {
  color: #5abb61;
}
.is-white {
  color: #fff;
}

.title {
  text-align: center;
}

.content p:not(:last-child), .content dl:not(:last-child), .content ol:not(:last-child), .content ul:not(:last-child), .content blockquote:not(:last-child), .content pre:not(:last-child), .content table:not(:last-child) {
  margin-bottom: 2rem;
}
.content-inner {

  p:last-child,
  dl:last-child,
  ol:last-child,
  ul:last-child,
  blockquote:last-child,
  pre:last-child,
  table:last-child {
    margin-bottom: 2rem;
  }
}

.checks {
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;

  .check {
    flex-basis: 20%;
    margin: 3rem 0;
    font-weight: 600;

    .icon {
      /* width: 5rem; */
      background: #73b86b;
      border-radius: 50%;
      color: #fff;
      width: 6rem;
      height: 6rem;
      margin-bottom: 1rem;

      .fa-3x {
        font-size: 4em;
      }
    }
  }
}

.faq-title {
  margin-bottom: 2rem;
}

.faq-item {
  margin-bottom: 3rem;
}

.content .title {
  margin-bottom: 2rem;
}

a.inherit-color {
  color: inherit;
  text-decoration: underline;
}

.section--123 .content-inner {

  ol {
    list-style-position: inside;
    margin-left: 0;
    color: #5abb61;
    font-weight: 600;
  }
  li>span>strong:first-child {
    margin-left: 20px;
  }
  ol span.normal {
    color: #343434;
    font-weight: normal;
  }

  ol>li {
    margin-bottom: 2rem;
  }

}


.features {
  display: flex;
  justify-content: space-around;
}
img.features-img {
  width: 80px;
}
.features-img-c {
  background: #fff;
  border-radius: 50%;
  width: 10rem;
  height: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}
.features p {
  text-align: center;
  font-weight: 800;
  margin-top: 1rem;
}
.b123-before {
  width: 100%;
  display: block;
}

.section--123>.container {
  background: url('../assets/123bg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.section--why {
  position: relative;
  padding-top: 5rem;
  padding-bottom: 12rem;
}

.section--why img.footer-before {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
}

.section--why>.container {
  position: relative;
  z-index: 2;
}

.before-a {
  display: block;
  width: 100%;
}
.before-a--creditcheck {
  background-color: #f9f9f9;
}
.before-a--creditcheck>path {
  fill: #abddad;
}

.before-a--getdecision>path {
  fill: #f9f9f9;
}


.section--getdecision:before {
  content: '';
  display: block;
  background: #f9f9f9;
  width: 40vw;
  height: 40vw;
  position: absolute;
  border-radius: 50%;
  left: -20vw;
  top: 0;
}

.section--getdecision:after {
  content: '';
  display: block;
  background: #f9f9f9;
  width: 20vw;
  height: 20vw;
  position: absolute;
  border-radius: 50%;
  right: -5vw;
  bottom: 0;
  z-index: -1;
}

.section--getdecision {
  position: relative;
}
.features-item {
  flex: 1;
  max-width: 160px;
}

.hero a.button.is-primary.is-large.is-rounded.is-fullwidth {
  display: block !important;
  height: auto;
}

.hero a.button.is-primary.is-large.is-rounded.is-fullwidth small {
  font-size: 0.75rem;
  display: block;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 4px;
  margin-top: -1px;
  color: rgba(255, 255, 255, 0.75);
}

.content.main-offer-terms-div {
  font-size: 0.7rem;
  text-align: center;
  background: #ffffff70;
  padding: 1rem;
  border-radius: 6px;
  color: #000000a6;
}
.content.main-offer-terms-div p {
    margin-bottom: 1rem;
}
.content.main-offer-terms-div p:last-child {
    margin-bottom: 0;
}

@media screen and (max-width:768px) {

  .hero.is-fullheight .main-offer-terms {
    font-size: 0.6rem;
  }

  body, .section {
    overflow-x: hidden;
    max-width: 100vw;
  }

  img.features-img {
    width: 40px;
  }
  .features-img-c {
    width: 80px;
    height: 80px;
    margin: auto;
  }
  .features-item {
    flex: 1;
  }
  .features p {
    font-size: 0.8rem;
  }
  .section--features {
    padding-top: 2rem;
    padding-bottom: 0.6rem;
  }

.checks {
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 3rem;

  .check .icon .fa-3x {
    font-size: 2rem;
  }
  .check .icon {
    width: 3rem;
    height: 3rem;
  }
  .check {
    flex-basis: 50%;
    margin: 1rem 0;
  }
}

  section:not(.section--about) .title span.is-block {
    display: inline !important;
  }
  .footer-logos>img {
    max-height: 25px;
    width: auto;
  }

  .section--why {
    padding-bottom: 3rem;
    padding-top: 3rem;
  }
  .section--why img.footer-before {
    left: -20%;
    right: -20%;
    width: 140%;
    max-width: 140%;
  }
  .section--getdecision:before {
    width: 100vw;
    height: 100vw;
    left: -60vw;
  }
  .section--getdecision:after {
    width: 80vw;
    height: 80vw;
    right: -40vw;
  }
}

@media screen and (min-width:320px) and (max-width:767px) and (orientation:landscape) {
  .rocket {
    display: none;
  }
  .green1 {
    display: block;
  }
  .hero.is-fullheight .scene .green {
    transform: scale(1.7);
    bottom: 0%;
  }
  .hero.is-fullheight .scene img.scene-item.green.green-rocket {
    bottom: 9% !important;
    transform: scale(0.25) !important;
    display: none;
  }
  .hero.is-fullheight {
    min-height: calc(100vh - 3.25rem) !important;
  }
}

/* ----------- iPhone X and XS Max ----------- */
@media only screen and (min-device-width : 375px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 3) and (orientation:landscape) {
  .rocket {
    display: none;
  }
  .hero.is-fullheight .scene .green {
    transform: scale(1.7);
    bottom: 0%;
  }
  img.scene-item.green.green1 {
    display: block;
  }
  .hero.is-fullheight .scene img.scene-item.green.green-rocket {
    bottom: 4% !important;
    transform: scale(.25) !important;
    display: none;
  }
  .hero.is-fullheight {
    min-height: calc(100vh - 3.25rem) !important;
  }
}
@media only screen and (min-width: 768px) {
  .hero.is-fullheight .scene .green {
    transform: scale(2.5);
  }
  .hero.is-fullheight .scene img.scene-item.green.green-rocket {
    bottom: 0% !important;
    transform: scale(0.25) !important;
  }

  .content .title {
    font-size: 3rem;
  }
}
@media only screen and (min-width: 1024px) and (orientation:landscape) {
  .hero.is-fullheight {
    background: -moz-linear-gradient(top, #7176bc 0%, #ffffff 80%);
    background: -webkit-linear-gradient(top, #7176bc 0%,#ffffff 80%);
    background: linear-gradient(to bottom, #7176bc 0%,#ffffff 80%);
    min-height: calc(100vh - 6.25rem);


    .title {
      font-size: 3.5rem;
    }
    .trustpilot-img {
      width: auto;
    }

    .scene {
      .green,
      .rocket {
        bottom: 0%;
        transform: scale(2);
      }
      .rocket {
        bottom: -36%;
      }
    }

  }

  .button.is-primary {
    width: 500px;
    margin: auto;
  }

}

/* ----------- iPad Pro ----------- */
/* Portrait and Landscape */
@media only screen
  and (min-width: 1024px)
  and (max-height: 1366px)
  and (-webkit-min-device-pixel-ratio: 1.5) {
    .hero.is-fullheight .scene img.scene-item.green.green-rocket {
      bottom: -12% !important;
    }
}

/* Portrait */
@media only screen
  and (min-width: 1024px)
  and (max-height: 1366px)
  and (orientation: portrait)
  and (-webkit-min-device-pixel-ratio: 1.5) {
}

/* Landscape */
@media only screen
  and (min-width: 1366px)
  and (max-height: 1366px)
  and (orientation: landscape)
  and (-webkit-min-device-pixel-ratio: 1.5) {
    .hero.is-fullheight .scene img.scene-item.green.green-rocket {
      bottom: 8% !important;
    }
}
@media only screen and (min-width: 900px) {
  div#navbarSpeedyLoans {
    position: absolute;
    right: 0;
    min-width: 20%;
  }
}
@media only screen and (min-width: 1280px) and (max-width: 1365px) {
  .hero.is-fullheight .scene img.scene-item.green.green-rocket {
    bottom: -16% !important;
  }
  .hero.is-fullheight .title {
    font-size: 3.5rem;
  }
}
@media only screen and (min-width: 1366px) {
  .hero.is-fullheight .scene img.scene-item.green.green-rocket {
    bottom: -14% !important;
  }
}
@media only screen and (min-width: 1440px) {
  .hero.is-fullheight .scene img.scene-item.green.green-rocket {
    bottom: -16% !important;
  }
  .hero.is-fullheight .title {
    margin-top: 2rem;
    font-size: 4rem;
  }
}

.hero.is-fullheight .scene .star {
  opacity: 0 !important;
}
.hero.is-fullheight .scene .star1 {
  animation: blink 3s linear infinite;
}
.hero.is-fullheight .scene .star2 {
  animation: blink 4s linear infinite;
  animation-delay: 1s;
}
.hero.is-fullheight .scene .star3 {
  animation: blink 5s linear infinite;
  animation-delay: 5s;
}
.hero.is-fullheight .scene .star4 {
  animation: blink 3s linear infinite;
  animation-delay: 1s;
}
.hero.is-fullheight .scene .star5 {
  animation: blink 3s linear infinite;
  animation-delay: 6s;
}
.hero.is-fullheight .scene .star6 {
  animation: blink 3s linear infinite;
  animation-delay: 3s;
}
.hero.is-fullheight .scene .star7 {
  animation: blink 4s linear infinite;
  animation-delay: 2s;
}
.hero.is-fullheight .scene .star8 {
  animation: blink 10s linear infinite;
  animation-delay: 2s;
}
.hero.is-fullheight .scene .star9 {
  animation: blink 2s linear infinite;
  animation-delay: 2s;
}
.hero.is-fullheight .scene .star10 {
  animation: blink 7s linear infinite;
  animation-delay: 5s;
}
.hero.is-fullheight .scene .star11 {
  animation: blink 5s linear infinite;
  animation-delay: 2s;
}
.hero.is-fullheight .scene .star12 {
  animation: blink 4s linear infinite;
  animation-delay: 3s;
}
.hero.is-fullheight .scene .star13 {
  animation: blink 2s linear infinite;
  animation-delay: 5s;
}
.hero.is-fullheight .scene .star14 {
  animation: blink 4s linear infinite;
  animation-delay: 3s;
}
.hero.is-fullheight .scene .star15 {
  animation: blink 6s linear infinite;
  animation-delay: 2s;
}
.hero.is-fullheight .scene .star16 {
  animation: blink 5s linear infinite;
  animation-delay: 1s;
}
@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
